import React from 'react';
import lodash from 'lodash';

import KogCheckbox from '../checkbox/kogCheckbox';

import KOGImage from '../kogImage/kogImage';
import { GetItemsByStatusResponse } from '@/main/models/response';
import { formatCurrency } from '@/main/services/utilsNumber';

import LoadingComponent from "../loading/loadingComponent";
import ColumnLabel from "../../common/columnLabel/columnLabel";
import * as S from "./styles";
import { IMAGE_DEFAULT } from "@/main/services/constants";
import { Controls } from "@/main/services/constants/constantsControl";
import { isNullUndefined, isShowControlByElementId } from "@/main/services/utils";
import QuoteProcurementPartInfo from '@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo';

interface IPartsListWithCheckbox {
  parts: GetItemsByStatusResponse[];
  optionsSelected: string[];
  setOptionsSelected: React.Dispatch<React.SetStateAction<string[]>>;
  title?: string | null;
  isLoading?: boolean;
}
function PartsListWithCheckbox({
  parts,
  optionsSelected,
  setOptionsSelected,
  title = null,
  isLoading = false
}: IPartsListWithCheckbox) {
  const showPrices = isShowControlByElementId(Controls.IdShowPrices);
  function handleToggleCheckbox(guid: string) {
    const cloneOptionsSelected = lodash.cloneDeep(optionsSelected);
    const index = cloneOptionsSelected.indexOf(guid);

    if (index > -1) {
      cloneOptionsSelected.splice(index, 1);
    } else {
      cloneOptionsSelected.push(guid);
    }

    setOptionsSelected(cloneOptionsSelected);
  }

  if (isLoading) return <LoadingComponent />;

  return (
    <>
      {title && <S.TitlePart>{title}</S.TitlePart>}
      <S.Container>
        {parts.map(option => (
          <S.Content key={option.guidProcurementSupplierItem}>
            <S.BoxPart>
              <S.BoxImagePart>
                <KOGImage src={option.image1 || IMAGE_DEFAULT} />
              </S.BoxImagePart>
              <S.BoxText>
                <QuoteProcurementPartInfo
                  data={option.quoteProcurementPartInfo}
                  renderType="column"
                />
                {showPrices && !isNullUndefined(option.price) && <S.TextPart>{formatCurrency(option.price)}</S.TextPart>}
              </S.BoxText>
              {option.quantityPart && option.quantityPart > 0 && (
                <S.WrapperQuantity>
                  <ColumnLabel
                    label={''}
                    content={<S.Quantity> {option.quantityPart}</S.Quantity>}
                  />
                </S.WrapperQuantity>
              )}
            </S.BoxPart>

            <KogCheckbox
              key={option.partGuid}
              checked={optionsSelected.includes(
                option.guidProcurementSupplierItem
              )}
              value={optionsSelected.includes(
                option.guidProcurementSupplierItem
              )}
              onChange={() =>
                handleToggleCheckbox(option.guidProcurementSupplierItem)
              }
            />
          </S.Content>
        ))}
      </S.Container>
    </>
  );
}
export default PartsListWithCheckbox;
